function canLog(): boolean {
  return typeof window !== 'undefined'
}

export function attributionDebug(message: string, context?: Record<string, unknown>): void {
  if (!canLog()) return

  if (context) {
    console.debug(`[attribution] ${message}`, context)
    return
  }

  console.debug(`[attribution] ${message}`)
}

export function attributionWarn(message: string, context?: Record<string, unknown>): void {
  if (!canLog()) return

  if (context) {
    console.warn(`[attribution] ${message}`, context)
    return
  }

  console.warn(`[attribution] ${message}`)
}

